import { Table } from "antd";
import { useContext, useEffect, useState } from "react";
import React from "react";
import moment from "moment";
import { WidgetCardContext } from "../WidgetCard/context";

const formatDateValue = (text, dateFormat) => {
  if (text == null || text === "") return text;
  const str = String(text);
  if (!/\d{4}-\d{2}-\d{2}/.test(str)) return text;
  const m = moment(str);
  return m.isValid() ? m.format(dateFormat) : str.slice(0, 10);
};

export const TableGrid = (props) => {
  const { currentComponent } = props;
  const { dateFormat } = useContext(WidgetCardContext) || {};
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const columns = [];
    let isFirstColumn = true;
    if (
      !currentComponent ||
      !Array.isArray(currentComponent) ||
      !currentComponent[0]
    ) {
      return; // or handle empty state
    }
    for (const [key] of Object.entries(currentComponent[0])) {
      const title = `${key.charAt(0).toUpperCase() +
        key.slice(1).replaceAll("_", " ")}`;
      const isDateCol = !!dateFormat && /date/i.test(key);
      const dd = {
        // title: `${key.charAt(0).toUpperCase() +
        //   key.slice(1).replaceAll("_", " ")}`,
        title: title,
        dataIndex: `${key}`,
        key: `${key}`,
        align: "left",
        width: isFirstColumn ? 200 : Math.max(100, title.length * 8),
        ellipsis: {
          showTitle: false,
        },
        render: (text) => {
          const display = isDateCol ? formatDateValue(text, dateFormat) : text;
          return <span title={display}>{display}</span>;
        },
      };
      columns.push(dd);
      setColumns(columns);
      isFirstColumn = false;
    }
    setData(currentComponent);
  }, [currentComponent, dateFormat]);

  return (
    <div>
      <Table
        dataSource={data}
        columns={columns}
        size="small"
        pagination={false}
        className="dashboard-tbl-scroll"
        scroll={{
          x: "max-content",
          y: 235,
        }}
      />
    </div>
  );
};
